$(document).ready(function () {
  $(document).on('click', '#openSizeChart', function (e) {
    e.preventDefault();

    const selectedChart = $(this).data("chart");

    $("#sizeChartModal .chart_content").each(function () {
      const attr = $(this).attr("data-atribute");
      if (attr === selectedChart) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    $("#sizeChartModal").css("display", "flex");

    setTimeout(function () {
      $("#sizeChartModal").addClass("active");
      $("body").addClass("modelOpen");
    }, 10); // Let browser apply `display: flex` before transition
  });

  function closeModal() {
    $("#sizeChartModal").removeClass("active");
    $("body").removeClass("modelOpen");

    // Wait for transition to complete before hiding
    setTimeout(function () {
      $("#sizeChartModal").css("display", "none");
    }, 300); // Match CSS transition duration
  }

  $(".close").on("click", closeModal);

  $(window).on("click", function (e) {
    if ($(e.target).is("#sizeChartModal")) {
      closeModal();
    }
  });
});

$(document).ready(function () {
  $(document).on('click', '#openSizeChartquick', function (e) {
    e.preventDefault();

    const selectedChart = $(this).data('chart');

    $('#sizeChartModalquick .chart_content').each(function () {
      const attr = $(this).attr('data-atribute');
      if (attr === selectedChart) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    $('#sizeChartModalquick').css('display', 'flex');

    setTimeout(function () {
      $('#sizeChartModalquick').addClass('active');
      $('body').addClass('modelOpen');
    }, 10);
  });

  function closeQuickModal() {
    $('#sizeChartModalquick').removeClass('active');
    $('body').removeClass('modelOpen');

    setTimeout(function () {
      $('#sizeChartModalquick').css('display', 'none');
    }, 300);
  }

  $(document).on('click', '.close', closeQuickModal);

  $(window).on('click', function (e) {
    if ($(e.target).is('#sizeChartModalquick')) {
      closeQuickModal();
    }
  });

  $(document).on('click', 'a[href*="#allSizeGuide"]', function (e) {
    e.preventDefault();

    $('#sizeChartModalquick .chart_content').each(function () {
      const attr = $(this).attr('data-atribute');
      if (attr === "allSizeGuide") {
        $('#sizeChartModalquick').addClass('all-size-guide')
        $(this).show();
      } else {
        $('#sizeChartModalquick').removeClass('all-size-guide')
        $(this).hide();
      }
    });

    $('#sizeChartModalquick').css('display', 'flex');

    setTimeout(function () {
      $('#sizeChartModalquick').addClass('active');
      $('body').addClass('modelOpen');
    }, 10);
  });
});



$(document).ready(function () {
  $(".box h3").click(function () {
    var $thisBox = $(this).closest(".box");

    // If this box is already open
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $thisBox.find(".content").slideUp();
    } else {
      // Close any open box
      $(".box h3").removeClass("active");
      $(".box .content").slideUp();

      // Open the clicked one
      $(this).addClass("active");
      $thisBox.find(".content").slideDown();
    }
  });
});

$(document).ready(function () {
  $('.profile-card ul li a').on('click', function (e) {

    // Remove 'active' from all links
    $('.profile-card ul li a').removeClass('active');

    // Add 'active' to the clicked one
    $(this).addClass('active');
  });
});


const target = document.body;
const observer = new MutationObserver(function () {
  if (!$(target).hasClass('rebuy-cart-visible')) {
    $(target).removeClass('overflow-hidden');
  }
});

observer.observe(target, {
  attributes: true,
  attributeFilter: ['class']
});

$(document).ready(function () {
  var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve(); }) });
  initGorgiasChatPromise.then(function () {
    var timer = setInterval(function () {
      var chatButtonHead = document.querySelector('#gorgias-chat-container')?.querySelector('#chat-button')?.contentWindow.document.querySelector('head');
      if (!chatButtonHead?.children.length) {
        return;
      }
      clearInterval(timer);
      var myButtons = document.querySelectorAll('a[href*="#gorgias-chat"]');
      myButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          if (GorgiasChat.isOpen()) {
            GorgiasChat.close();
          } else {
            GorgiasChat.open();
          }
        });
      });
    }, 50);
  });
});

$(document).ready(function () {
    const target = document.querySelector('sticky-header');

    if (target) {
      const observer = new MutationObserver(function () {
        if ($(target).hasClass('rebuy-position-relative')) {
          $('.body-overlay').addClass('overlay-rebuy');
        } else {
          $('.body-overlay').removeClass('overlay-rebuy');
        }
      });

      observer.observe(target, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  });


